import { BrandConfig } from '../types';

export const everiConfig: BrandConfig = {
  id: 'everi',
  name: 'Everi',
  displayName: 'Everi',
  logo: 'Everi.svg',
  primaryColor: '#0047BB',
  categories: [
    {
      name: 'Everi Games',
      banner: 'banners/banner_Everi.jpg',
      gamesPath: 'brands/everi.json',
      brandIcon: 'logo_everi.png',
      comingSoon: false,
      disabled: false
    },
    {
      name: 'FanDuel',
      banner: 'banners/banner_Fanduel.jpg',
      gamesPath: 'brands/fanduel.json',
      brandIcon: 'logo_fanduel.png',
      comingSoon: false,
      disabled: false
    },
    {
      name: 'BetMGM',
      banner: 'banners/banner_everi-betmgm.jpg',
      gamesPath: 'brands/betmgm.json',
      ipKeys: ['The Price Is Right', 'Family Feud'],
      brandIcon: 'logo_betmgm.png',
      comingSoon: false,
      disabled: false
    }
  ],
  defaultBanners: [
    'banners/banner_Everi.jpg',
    'banners/banner_Fanduel.jpg',
    'banners/banner_everi-betmgm.jpg'
  ]
};
